'use client';

import { c as _c } from "react/compiler-runtime";
import { ButtonStyle } from '@sola/ark-core/atoms/button-style/button-style.tsx';
import { Alert } from '@sola/ark-core/molecules/alert/alert.tsx';
import { ChildImageVariantEnum } from '@sola/ark-core/utils/child-image.ts';
import { ArkIcon } from '@sola/ark-icons/lib/ark-icon.tsx';
import type { BlockProps, ComponentBaseProps } from '@sola/schema/lib/schema.ts';
import { ChildSpotlightCard, ChildSpotlightCardActionItem, ChildSpotlightImage } from '../../molecules/child-spotlight-card/child-spotlight-card.tsx';
import { useSpotlightCardDeparture } from './spotlight-card-departure.logic.tsx';
export interface SpotlightCardDepartureProps extends BlockProps, ComponentBaseProps {
  globalId?: string;
  sponsorYears?: number;
  unexpected?: boolean;
  videoHref?: string;
}
export const SpotlightCardDeparture: React.FC<SpotlightCardDepartureProps> = t0 => {
  const $ = _c(46);
  const {
    globalId,
    sponsorYears,
    unexpected: t1,
    videoHref: t2
  } = t0;
  const unexpected = t1 === undefined ? false : t1;
  const videoHref = t2 === undefined ? "#departure-video" : t2;
  const {
    t,
    isLoading,
    hasError,
    cardData
  } = useSpotlightCardDeparture(globalId, unexpected);
  if (!globalId) {
    return null;
  }
  if (isLoading) {
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <div className="DeparturePage__card max-w-md rounded-lg p-comfy-xl"><div className="DeparturePage__loading h-roomy-lg rounded-lg" /></div>;
      $[0] = t3;
    } else {
      t3 = $[0];
    }
    return t3;
  }
  if (hasError || !cardData) {
    let t3;
    if ($[1] !== t) {
      t3 = t("my:sponsorshipRelationship.childBio.alert.title");
      $[1] = t;
      $[2] = t3;
    } else {
      t3 = $[2];
    }
    let t4;
    if ($[3] !== t) {
      t4 = t("my:sponsorshipRelationship.childBio.alert.message");
      $[3] = t;
      $[4] = t4;
    } else {
      t4 = $[4];
    }
    let t5;
    if ($[5] !== t3 || $[6] !== t4) {
      t5 = <Alert variant="negative" title={t3} message={t4} />;
      $[5] = t3;
      $[6] = t4;
      $[7] = t5;
    } else {
      t5 = $[7];
    }
    return t5;
  }
  let t3;
  if ($[8] !== cardData.childImageUrl || $[9] !== cardData.childName) {
    t3 = <ChildSpotlightImage childImageUrl={cardData.childImageUrl} alt={cardData.childName} variantMd={ChildImageVariantEnum.Full} />;
    $[8] = cardData.childImageUrl;
    $[9] = cardData.childName;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== cardData.childName || $[12] !== cardData.titleKey || $[13] !== t) {
    t4 = t(cardData.titleKey, {
      childName: cardData.childName
    });
    $[11] = cardData.childName;
    $[12] = cardData.titleKey;
    $[13] = t;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== t4) {
    t5 = <h2 className="ChildSpotlightCard__title m-none w-full heading-neutral-amplified heading-sm md:heading-md">{t4}</h2>;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== cardData.childName || $[18] !== sponsorYears || $[19] !== t) {
    t6 = t("my:sponsorshipRelationship.departures.spotlight.departure.descriptionIntro", {
      childName: cardData.childName,
      sponsorYears
    });
    $[17] = cardData.childName;
    $[18] = sponsorYears;
    $[19] = t;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  let t7;
  if ($[21] !== t6) {
    t7 = <p>{t6}</p>;
    $[21] = t6;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] !== cardData.childName || $[24] !== t) {
    t8 = t("my:sponsorshipRelationship.departures.spotlight.departure.descriptionVideo", {
      childName: cardData.childName
    });
    $[23] = cardData.childName;
    $[24] = t;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  let t9;
  if ($[26] !== t8) {
    t9 = <p>{t8}</p>;
    $[26] = t8;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  let t10;
  if ($[28] !== t7 || $[29] !== t9) {
    t10 = <div className="ChildSpotlightCard__description w-full body-neutral-mild body-sm md:body-md">{t7}{t9}</div>;
    $[28] = t7;
    $[29] = t9;
    $[30] = t10;
  } else {
    t10 = $[30];
  }
  let t11;
  if ($[31] !== t10 || $[32] !== t5) {
    t11 = <div className="ChildSpotlightCard__text flex w-full flex-col gap-comfy-xs">{t5}{t10}</div>;
    $[31] = t10;
    $[32] = t5;
    $[33] = t11;
  } else {
    t11 = $[33];
  }
  let t12;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <ArkIcon iconName="play-circle" />;
    $[34] = t12;
  } else {
    t12 = $[34];
  }
  let t13;
  if ($[35] !== t) {
    t13 = t("my:sponsorshipRelationship.departures.spotlight.departure.primaryAction");
    $[35] = t;
    $[36] = t13;
  } else {
    t13 = $[36];
  }
  let t14;
  if ($[37] !== t13 || $[38] !== videoHref) {
    t14 = <div className="ChildSpotlightCard__actions flex flex-col gap-snug-xl w-full @md:items-start"><ChildSpotlightCardActionItem className="w-full @md:w-fit @md:flex-none"><ButtonStyle className="w-full @md:w-auto inline-flex" iconBefore={t12} size="lg" variant="secondary"><a href={videoHref}>{t13}</a></ButtonStyle></ChildSpotlightCardActionItem></div>;
    $[37] = t13;
    $[38] = videoHref;
    $[39] = t14;
  } else {
    t14 = $[39];
  }
  let t15;
  if ($[40] !== t11 || $[41] !== t14) {
    t15 = <div className="flex h-full flex-col justify-center gap-comfy-lg md:p-roomy-xs">{t11}{t14}</div>;
    $[40] = t11;
    $[41] = t14;
    $[42] = t15;
  } else {
    t15 = $[42];
  }
  let t16;
  if ($[43] !== t15 || $[44] !== t3) {
    t16 = <ChildSpotlightCard image={t3}>{t15}</ChildSpotlightCard>;
    $[43] = t15;
    $[44] = t3;
    $[45] = t16;
  } else {
    t16 = $[45];
  }
  return t16;
};